import React, { useContext, useEffect, useState } from 'react'

import { LinearProgress } from '@material-ui/core'
import EventData from '../../components/EventData'
import EventInfo from '../../components/EventInfo'
import EventsOthersInfo from '../../components/EventsOthersInfo'
import EventsValuesData from '../../components/EventsValuesData'
import FormNavigation from '../../components/FormNavigation'

import changeLogo from '../../assets/images/altera-logo.png'
import Context from '../../context'
import { ParserTags } from '../../helpers/ParserHelper'
import { FORM_OBJECT, OBLIGATED_FIELDS } from '../../helpers/Variables'
import { addEvent, getEventById, getThemesList } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

import ImageUploadToS3ge from '../../services/ImageUpload'
// import ProgressBar from '../../components/ProgressBar';

import EventsTypeDiscounts from '../../components/EventsTypeDiscounts'
import OffersSelector from '../../components/OffersSelector'
import ToastMessages from '../../components/ToastMessages'
import {
  EventValues,
  ListDate,
  ParserEventsPricingInvert,
  ParserListDateInvert,
  ParserPartnerCodesItens,
  ParserPartnerCodesItensInvert
} from '../../helpers/EventValuesHelper'

const { REACT_APP_IMAGES_URL } = process.env

function EventForm() {
  const { user, setUser, setAboutCurrentPage, editEvent, setOpenToast, setShowLoadingModal } =
    useContext(Context)
  const [formObject, setFormObject] = useState(FORM_OBJECT)
  const [obligatedList, setObligatedList] = useState(OBLIGATED_FIELDS)
  const [isLoading, setIsLoading] = useState(true)
  const [steps, setSteps] = useState({
    step: 1,
    maxStep: 5
  })
  const [newLogo, setNewLogo] = useState(changeLogo)
  const [iconLogo, setIconLogo] = useState(changeLogo)
  const [logoToUpload, setLogoToUpload] = useState(null)
  const [crop, setCrop] = useState({
    aspect: 3 / 2,
    unit: '%',
    width: 50,
    height: 50,
    x: 25,
    y: 10
  })
  const [tags, setTags] = useState([])
  const [listDate, setListDate] = useState(ListDate)
  const [eventsValuesList, setEventsValuesList] = useState([...EventValues])
  const [selectedAmenitiesOnEdit, setSelectedAmenitiesOnEdit] = useState([])
  const [openProducerModal, setOpenProducerModal] = useState(false)
  const [openPlaceModal, setOpenPlaceModal] = useState(false)
  const [whiteLabels, setWhiteLabels] = useState([])
  const [partnersCodesItens, setPartnersCodesItens] = useState([])

  const [missInputs, setMissInputs] = useState(false)

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser())
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Adicionar Evento',
      buttons: [
        {
          title: 'Voltar',
          pathname: '/eventslist'
        }
      ]
    })

    let whitelabelPromise = getThemesList().then(r => {
      setWhiteLabels([...r])
    })
    Promise.all([whitelabelPromise]).then(() => setIsLoading(false))
  }, [])

  useEffect(() => {
    if (user?.userGroup === 6 || user?.userGroup === 7) {
      setSteps(steps => ({ ...steps, maxStep: 4 }))
    }
  }, [user])

  useEffect(() => {
    if (editEvent.id) {
      setIsLoading(true)
      getEventById(editEvent.id).then(r => {
        if (r) {
          const {
            EventsAmenities,
            EventsTags,
            EventsProgrammings,
            amountOfCourtesies,
            EventsPricings,
            PartnerCodesItens
          } = r

          setListDate(ParserListDateInvert(EventsProgrammings))
          setEventsValuesList(ParserEventsPricingInvert(EventsPricings))

          if (PartnerCodesItens) {
            setPartnersCodesItens(ParserPartnerCodesItensInvert(PartnerCodesItens))
          }

          setFormObject({
            ...editEvent,
            ...r,
            hasCourtesy: amountOfCourtesies !== null
          })
          setNewLogo(`${REACT_APP_IMAGES_URL}${r.cover}`)
          setIconLogo(`${REACT_APP_IMAGES_URL}${r.cover}`)
          setLogoToUpload(r.cover)

          const newAmenities = EventsAmenities.map(item => {
            return item.amenitiesId
          })
          setSelectedAmenitiesOnEdit([...newAmenities])
          const selectedTags = EventsTags.map(tag => {
            return tag.tagsId
          })
          setTags([...selectedTags])
          setIsLoading(false)
        }
      })
    } else {
      setFormObject(FORM_OBJECT)
    }
  }, [editEvent])

  const handleContinue = async () => {
    if (steps.step < steps.maxStep) {
      setSteps({ ...steps, step: steps.step + 1 })
    }

    if (steps.step === steps.maxStep && !missInputs) {
      if (!formObject.mainTag)
        return setOpenToast({
          open: true,
          message: 'Escolha uma categoria para o evento',
          type: 'error'
        })

      setIsLoading(true)
      setShowLoadingModal(true)
      let cover = ''

      if (logoToUpload !== undefined && typeof logoToUpload !== 'string') {
        try {
          cover = await ImageUploadToS3ge(logoToUpload)
        } catch (e) {
          console.log('Não conseguiu enviar a logo', e)
        }
      } else {
        cover = logoToUpload || formObject.cover
      }

      const eventToSave = {
        ...formObject,
        cover,
        eventsTags: ParserTags(tags),
        partnersCodesItens: ParserPartnerCodesItens(partnersCodesItens),
        eventsWhiteLabels: !formObject.eventsWhiteLabels?.length
          ? user?.WhiteLabel
            ? [{ whiteLabelId: user?.WhiteLabel?.id }]
            : []
          : formObject.eventsWhiteLabels
      }

      addEvent(eventToSave)
        .then(() => {
          const toastMessage = eventToSave.id
            ? 'Evento Atualizado com Sucesso.'
            : 'Evento Criado com Sucesso.'
          setShowLoadingModal(false)
          history.push('/eventslist', {
            showToast: true,
            toastMessage
          })
        })
        .catch(error => {
          console.log('EventError', error)
          setShowLoadingModal(false)
          setOpenToast({
            open: true,
            message: 'Ocorreu algum erro ao salvar',
            type: 'error'
          })
        })
    } else if (missInputs) {
      setOpenToast({
        open: true,
        message: 'Existem campos obrigatórios sem preencher, favor verificar todos os campos',
        type: 'error'
      })
    }
  }

  const checkIsEmpty = (key, value) => {
    if (obligatedList.filter(item => item.key === key).length > 0 && value.length === 0) {
      const newArr = obligatedList.map(item => {
        if (item.key === key) {
          setOpenToast({
            open: true,
            message: item.message,
            type: 'error'
          })
          return { ...item, showRed: true }
        }
        return { ...item }
      })
      setObligatedList(newArr)
      setMissInputs(true)
    } else {
      const newArr = obligatedList.map(item => {
        if (item.key === key) {
          setOpenToast({
            open: false,
            message: '',
            type: 'error'
          })
          return { ...item, showRed: false }
        }
        return { ...item }
      })
      setObligatedList(newArr)
      setMissInputs(false)
    }
  }

  const checkIsRed = key => {
    const obj = obligatedList.find(item => item.key === key)
    if (obj) {
      return obj.showRed || false
    }
    return false
  }

  return (
    <div className="container-fluid">
      <ToastMessages />
      {isLoading ? (
        <LinearProgress marginBottom="30px" />
      ) : (
        <Context.Provider
          value={{
            tags,
            setTags,
            formObject,
            setFormObject,
            newLogo,
            setNewLogo,
            iconLogo,
            setIconLogo,
            crop,
            setCrop,
            logoToUpload,
            setLogoToUpload,
            selectedAmenitiesOnEdit,
            setSelectedAmenitiesOnEdit,
            listDate,
            setListDate,
            eventsValuesList,
            setEventsValuesList,
            setOpenToast,
            obligatedList,
            setObligatedList,
            openProducerModal,
            setOpenProducerModal,
            openPlaceModal,
            setOpenPlaceModal,
            whiteLabels,
            partnersCodesItens,
            setPartnersCodesItens
          }}
        >
          <form
            className="clube-form form-row"
            onSubmit={e => {
              e.preventDefault()
            }}
          >
            <div className="col-12">
              {steps.step === 1 && <EventData checkValue={checkIsEmpty} checkIsRed={checkIsRed} />}
              {steps.step === 2 && <EventsOthersInfo />}
              {steps.step === 3 && <EventInfo checkValue={checkIsEmpty} checkIsRed={checkIsRed} />}
              {steps.step === 4 && steps.maxStep > 4 && (
                <>
                  <OffersSelector />
                  <EventsTypeDiscounts />
                </>
              )}
              {steps.step === steps.maxStep && <EventsValuesData />}
            </div>
          </form>
          <div className="col-12">
            <button onClick={handleContinue} type="button" className="btn clube-button clube-blue">
              {steps.step !== steps.maxStep ? 'Continuar' : 'Salvar'}
            </button>
          </div>
        </Context.Provider>
      )}
      <Context.Provider value={{ steps, setSteps }}>
        <FormNavigation />
      </Context.Provider>
    </div>
  )
}

export default EventForm
